import { DateTime } from 'luxon'

import { DateOptions } from './CustomSingleSelect'

const Caption = ({ fields, showLabel }: { fields: Record<string, string | React.ReactNode>; showLabel?: boolean }) => {
  if (!showLabel) {
    // return <div>{JSON.stringify(fields)}</div>
    return (
      <div>
        {Object.entries(fields).map(([label, value], idx) => (
          <span key={label}>
            {idx > 0 && ' / '}
            {value}
          </span>
        ))}
      </div>
    )
  }
  return (
    <div>
      {Object.entries(fields).map(([k, v]) => (
        <span className="mr-2" key={k}>
          <span className="text-gray-400 mr-1">{k}</span>
          <span className="text-gray-800">{v}</span>
        </span>
      ))}
    </div>
  )
}

interface DateCaptionParams {
  from?: string | Date
  to?: string | Date
  date?: string
  fields: Record<string, string | React.ReactNode>
  finite?: boolean
}
export const addDateToCaptionFields = ({ from, to, date, fields, finite }: DateCaptionParams) => {
  if (date && date !== 'custom') {
    const label = DateOptions.find((d) => d.value === date)?.label
    if (label) {
      fields['Date'] = label
    }
  } else if (from) {
    const f = typeof from === 'string' ? DateTime.fromISO(from) : DateTime.fromJSDate(from)
    if (to) {
      const t = typeof to === 'string' ? DateTime.fromISO(to) : DateTime.fromJSDate(to)
      fields['Date'] = `${f.toFormat('yyyy/MM/dd')} - ${t.toFormat('yyyy/MM/dd')}`
    } else {
      fields['Date'] = `${f.toFormat('yyyy-MM-dd')}${finite ? ' - current' : ''}`
    }
  } else if (to) {
    const t = typeof to === 'string' ? DateTime.fromISO(to) : DateTime.fromJSDate(to)
    fields['Date'] = `${finite ? ' - ' : ''}${t.toFormat('yyyy-MM-dd')}`
  }
}

export default Caption
